import {
  GetStockNewsParams,
  StockInstrumentData,
  StockNewsPage,
} from "@crypto-trading/common/browser";
import { ApiClientManager } from "@/utils/api-client-factory";

export const getStockNews = async (
  userId: string,
  params?: GetStockNewsParams
): Promise<StockNewsPage> => {
  return ApiClientManager.getStockNewsClient().getStockNews(userId, params);
};

export const getStockInstruments = async (): Promise<StockInstrumentData[]> => {
  return ApiClientManager.getStockNewsClient().getStockInstruments();
};
